import React, { useState, useEffect } from "react";
import { Paper, TableRow, TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  ModalDeleteConfirm,
  TableAction,
  TableCellDefault,
  DatatablesFooterServerSide,
  Title,
  Loading,
} from "App/Component/ui";
import FormFilter from "./FormFilter";
import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  deleteFixedAssetById,
  getByFilterFA,
  headCells,
  RenderStatusKelengkapanBadge,
  RESET_STATE_FORM_FILTER,
  // urlGetFixedAsset,
} from "./helpers";
import {
  WMS_FA_INPUT,
  NAME_WMS_FA_INPUT,
  STYLE_DEFAULT_MASTER,
} from "App/constants";
import {
  defaultDateDisplay,
  // formatRupiah,
  defaultToastSuccess,
  defaultToastError,
  isNull,
  convertToValidPrice,
  formatRupiah,
} from "App/utils/helpers";
import { handleClickCetakLabelAsset } from "App/Component/layout/Registrasi/utils";
import { FreezeTable } from "components/organism";
import FormImportFixedAsset from "./FormImportFixedAsset";
import { getIDunit } from "App/utils/cookies";
import { useSelector } from "react-redux";

export default function DaftarFixedAsset({
  changeParentData,
  changeTitle,
  changeMenu,
  handleClickMenu,
}) {
  const master = useSelector(({ master }) => master);
  const fullAkses = master.access_fa.access;
  const classes = STYLE_DEFAULT_MASTER();
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    code: "",
  });
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.halaman,
    limit = formFilter.jumlah
  ) => {
    setLoading(true);
    // console.log("fullAkses", fullAkses);
    // console.log("fullAkses", {unit_id: fullAkses ? null : getIDunit()});
    const res = await getByFilterFA(
      {
        ...formFilter,
        withFilterUnit: !fullAkses,
        unit_id: fullAkses ? null : getIDunit(),
      },
      pages,
      limit
    );
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  function clickUpdate(row) {
    Promise.resolve()
      .then(() => {
        changeMenu(WMS_FA_INPUT);
      })
      .then(() => {
        changeParentData({
          id: row?.id,
          idgl: row?.idgl,
          total_penyusutan: row?.total_penyusutan,
          total_cicilan: 0,
          sisa_pemby: 0,
          id_pembelian: row?.id_pembelian,
          disabledInput: false,

          // tgl_pembelian: defaultDateInputDisplay(row?.tgl_pembelian, true),
          // tgl_pemakaian: defaultDateInputDisplay(row?.tgl_pemakaian, true),
          // tgl_akhirpenyusutan: defaultDateInputDisplay(
          //   row?.tgl_akhirpenyusutan,
          //   true
          // ),

          // perkiraan_umur_thn: row?.perkiraan_umur_thn,
          // perkiraan_umur_bln: row?.perkiraan_umur_bln,

          // nilai_sisaditaksir: row?.nilai_sisaditaksir,
          // nilai_sisaditaksir2: formatRupiah(row?.nilai_sisaditaksir),

          // nilai_aset: row?.nilai_aset,
          // nilai_aset2: formatRupiah(row?.nilai_aset),

          // is_asetberwujud: row?.is_asetberwujud,
          // is_perhitungansusut: row?.is_perhitungansusut,
          // gudang_id: row?.gudang_id,
          // produsen_id: row?.produsen_id,
          // supplier_id: row?.supplier_id,
          // metode_penyusutan_id: row?.metode_penyusutan_id,
          // masa_manfaat: row?.masa_manfaat,
          // tarif_penyusutan: row?.tarif_penyusutan,
          // coa_fixassets_id: 1,
          // coa_akumulasi_id: 1,
          // coa_bebanpenyusutan_id: 1,

          // tingkatasset_id: row?.tingkatasset_id,
          // remark: row?.remark,
          // status: row?.status,
          // role_id: row?.role_id,
        });
        changeTitle(WMS_FA_INPUT);
        handleClickMenu({
          name: NAME_WMS_FA_INPUT,
          code: WMS_FA_INPUT,
        });
      });
  }

  function clickDelete(row) {
    setFormData({
      id: row?.id,
      code: row?.code,
      name: row?.name,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  function clickCetak(row) {
    handleClickCetakLabelAsset(
      {
        code: row.code,
        name: row.name,
      },
      "print-fixed-asset-label"
    );
  }

  async function deleteList() {
    const res = await deleteFixedAssetById(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar Fixed Asset"} />
        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}
        {fullAkses ? (
          <div className="mb-2">
            <FormImportFixedAsset
              file={file}
              setFile={setFile}
              setNewData={setNewData}
            />
          </div>
        ) : (
          <></>
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <FormFilter
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            withExportButton={true}
            fullAkses={fullAkses}
          />
          <Loading show={loading} />
          <TableDaftarFA
            rows={rows}
            classes={classes}
            clickDelete={clickDelete}
            clickUpdate={clickUpdate}
            clickCetak={clickCetak}
            fullAkses={fullAkses}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

const TableDaftarFA = ({
  rows,
  classes,
  clickUpdate,
  clickDelete,
  clickCetak,
  fullAkses = true,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={index}
            // style={{
            //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
            // }}
          >
            <TableCell scope="row" padding="none" align="center">
              {index + 1}
            </TableCell>
            <TableCell scope="row" padding="none" align="center">
              {fullAkses ? (
                <>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                    clickCetak={() => clickCetak(row)}
                    isCetak={true}
                  />
                </>
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">{row?.name}</TableCell>
            <TableCell align="left">{row?.code}</TableCell>
            <TableCell align="left">
              {isNull(row?.merek) ? "-" : row?.merek}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.type) ? "-" : row?.type}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.idgl) ? "-" : row?.idgl}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.id_pembelian) ? "-" : row?.id_pembelian}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.nama_typeasset) ? "-" : row?.nama_typeasset}
            </TableCell>
            <TableCell align="left">
              <RenderStatusKelengkapanBadge status={row.status_kelengkapan} />
            </TableCell>
            <TableCell align="left">
              {isNull(row?.harga_perolehan)
                ? "-"
                : formatRupiah(row?.harga_perolehan)}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.kondisi_barang) ? "-" : row?.kondisi_barang}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.no_sn) ? "-" : row?.no_sn}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.no_akd) ? "-" : row?.no_akd}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.no_akl) ? "-" : row?.no_akl}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.nofaktur) ? "-" : row?.nofaktur}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.gudang) ? "-" : row?.gudang}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.supplier) ? "-" : row?.supplier}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.produsen) ? "-" : row?.produsen}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.tgl_pembelian)
                ? "-"
                : defaultDateDisplay(row?.tgl_pembelian)}
            </TableCell>
            {/* <TableCell align="left">{row?.tingkatasset_id}</TableCell>
                <TableCell align="left">{row?.gudang_id}</TableCell>
                <TableCell align="left">{row?.nofaktur}</TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.tgl_pembelian)}
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.tgl_pemakaian)}
                </TableCell>{" "}
                <TableCell align="left">
                  {defaultDateDisplay(row?.tgl_akhirpenyusutan)}
                </TableCell>
                <TableCell align="left">{row?.remark}</TableCell> */}
            {/* <TableCell align="right">
                  {formatRupiah(row?.tarif_penyusutan)}
                </TableCell>
                <TableCell align="right">
                  {formatRupiah(row?.tarif_penyusutan)}
                </TableCell>
                <TableCell align="right">
                  {formatRupiah(row?.tarif_penyusutan)}
                </TableCell>
                <TableCell align="right">
                  {formatRupiah(row?.total_penyusutan)}
                </TableCell>
                <TableCell align="right">
                  {formatRupiah(row?.total_cicilan)}
                </TableCell>
                <TableCell align="right">
                  {formatRupiah(row?.sisa_pemby)}
                </TableCell>
                <TableCell align="left">
                  {row?.status ? "Active" : "Inactive"}
                </TableCell> */}
            <TableCellDefault row={row} />
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
